// Utils
import { AccountCardsListAllQuery, AccountCardsListAllDocument } from '@gql';
import { createApolloClient } from '../apollo-node-client';

export const imperativeNodeAccountCardQuery = async (accessToken: string) => {
  const apolloClient = createApolloClient(accessToken);

  const response = await apolloClient.query<AccountCardsListAllQuery>({
    ...{ query: AccountCardsListAllDocument },
  });

  return { ...response, apolloClient };
};
